<template>
    <div class="flex flex-wrap space-y-5 lg:space-y-0" v-if="appointmentToday">
        <div class="relative w-full lg:w-[300px] rounded-2xl overflow-hidden bg-white border border-gray-900/[.04]">
            <div class="relative aspect-w-16 aspect-h-9">
                <img :src="branchImage" alt="" class="absolute top-0 left-0 object-cover w-full h-full">
            </div>
            <div class="p-4">
                <p class="font-bold text-darkgray-800">
                    {{ appointmentToday.branch_name }}
                </p>
            </div>
        </div>
        <div class="w-full lg:w-[calc(100%-300px)] pl-5 space-y-1 text-darkgray-900">
            <p class="font-bold line-clamp-1 overflow-hidden text-ellipsis">
                <!-- {{ appointmentToday.package_name ?? appointmentToday.riders ?? 'N/A' }}  -->
                {{ appointmentToday.package_name ?? 'Selected Procedures Only' ?? 'N/A' }} 
            </p>
            <p class="">
                {{ formatDate(appointmentToday?.booking_date ?? new Date(), 'UTC','EEE, MMM dd') }}
                <span>
                    | {{ formatTime(appointmentToday?.booking_start_time ?? new Date(), 'UTC', 'h:mm a')}} -
                    {{ formatTime(appointmentToday?.booking_end_time ?? new Date(), 'UTC', 'h:mm a')}}
                </span>
            </p>
        </div>
    </div>
    <div v-else>
        No appointment scheduled for today
    </div>
</template>

<script setup lang="ts">
import { format } from 'date-fns'
import { computed, onMounted, ref } from 'vue';
import BranchService from "@/classes/Branch";
import { formatDate, formatTime } from '@/helpers/TimeFormatter';

const props = defineProps ({
    appointmentToday: {
        type: Object,
    }
});

const branchImage = ref(null)
const storageUrl = computed(() => process.env.VUE_APP_API_STORAGE_URL);

const fetchBranch = async () => {
    try {
        const response = await BranchService.editBranch(props.appointmentToday?.branch_id)

        const branchResponse = response.data.branch;

        if(branchResponse) {
            // branchImage.value = branchResponse.image_path ? `${storageUrl.value}${branchResponse.image_path}` : '/assets/images/shinagawa-bgc-branch.jpeg';
            branchImage.value = branchResponse.image_path ? branchResponse.full_image_path : '/assets/images/shinagawa-bgc-branch.jpeg';
        }
    }
    catch(error: any) {
        console.log(error)
    }
}

onMounted( () => {
    setTimeout(() => {
        if(props.appointmentToday?.branch_id) {
            fetchBranch();
        }   
    }, 1000);
})
</script>